var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center",attrs:{"id":"login-footer"}},[_c('div',[_vm._v("12 Horas Envíos")]),_c('div',{staticStyle:{"color":"#FCA721"}},[_vm._v("contacto@12horasenvios.com")])])
}]

export { render, staticRenderFns }